/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { IResourceProps } from 'apmui/resource/ResourceLoader';
import { RESOURCE } from 'apmui/resource/ResourceType';
import { WebtopResourceModel } from 'apmui/resource/WebtopResourceModel';

class NetworkAccessModel extends WebtopResourceModel {
    //
    static readonly propNames = ['autolaunch', ...WebtopResourceModel.propNames];
    //
    type: RESOURCE.NETWORK_ACCESS = RESOURCE.NETWORK_ACCESS;
    autoLaunch: boolean;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);
        this.autoLaunch = resource.props.autolaunch === '1';
        this.undefinedIconToDefault();
    }

    getPropNames(): string[] {
        return NetworkAccessModel.propNames;
    }
}

export { NetworkAccessModel as default, NetworkAccessModel };
